import axios from "axios";
import * as types from '../constants/ActionTypes'
import { toast } from 'react-toastify';

// Url's
const storeUrl = `${process.env.REACT_APP_API_URL}mobileshop/csacatalog/get-store-list`;
const storeStatesUrl = `${process.env.REACT_APP_API_URL}mobileshop/csacatalog/get-store-state-list`;
const storeTownUrl = `${process.env.REACT_APP_API_URL}mobileshop/csacatalog/get-store-town-list`;
const updateStoreUrl = `${process.env.REACT_APP_API_URL}mobileshop/csacatalog/update-store-code`;

// Actions
const storeSuccess = data => ({
  type: types.STORE_SUCCESS,
  data
});

const storeRequested = () => ({
  type: types.STORE_REQUEST
});

const storeSelected = (selectedStore) => ({
  type: types.STORE_SELECT,
  selectedStore
});

const storeStatesList = (storeStates) => ({
  type: types.STORE_STATE_LIST,
  storeStates
});

const storeFailure = error => ({
  type: types.STORE_FAILURE,
  error
});

const storeOpen = () => ({
  type: types.STORE_OPEN,
});


// API
export const getStore = (connection_id) => {
  return dispatch => {
    dispatch(storeRequested());
    axios.get(storeUrl, {
      params: {
        connection_id
      },
    })
      .then(res => {
        if (res.data.ack === "Success") {
          dispatch(storeSuccess(res.data.results));
        } else if (res.data.ack === "Failure") {
          dispatch(storeFailure(res.data.status));
        }
      })
      .catch(err => {
        throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};

export const saveStore = (store, connection_id, web_session_trans_id) => {
  const options = {
    connection_id,
    "store_code": store.ASM_ASSOC_CD,
    web_session_trans_id

  }
  return dispatch => {
    // dispatch(storeRequested());
    axios.post(updateStoreUrl, options, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        //'Content-Type': 'application/json; charset=UTF-8'
      },
    })
      .then(res => {
        if (res.data.ack === "Success") {
          // dispatch(storeSuccess(res.data.results));
          dispatch(storeSelected(store));
          toast.success(`Your orders will be booked at - ${store.ASM_STORE}`);
        } else if (res.data.ack === "Failure") {
          toast.success(`Store selection failed!`);
          // dispatch(storeFailure(res.data.status));
        }
      })
      .catch(err => {
        throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};

export const storeToggle = (connection_id) => {
  return dispatch => {
    dispatch(storeOpen());
    dispatch(storeRequested());
    axios.get(storeUrl, {
      params: {
        connection_id
      },
    })
      .then(res => {
        if (res.data.ack === "Success") {
          dispatch(storeSuccess(res.data.results));
        } else if (res.data.ack === "Failure") {
          dispatch(storeFailure(res.data.status));
        }
      })
      .catch(err => {
        throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};
//get store state list
export const getStoreStates = (connection_id) => {
  return dispatch => {
    dispatch(storeRequested());
    axios.get(storeStatesUrl, {
      params: {
        connection_id
      },
    })
      .then(res => {
        if (res.data.ack === "Success") {
          dispatch(storeStatesList(res.data.results));
        } else if (res.data.ack === "Failure") {
          dispatch(storeFailure(res.data.status));
        }
      })
      .catch(err => {
        throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};



export const getTownList = (connection_id) => {
  return dispatch => {
    dispatch(storeRequested());
    axios.get(storeTownUrl, {
      params: {
        connection_id
      },
    })
      .then(res => {
        if (res.data.ack === "Success") {
          dispatch(storeStatesList(res.data.results));
        } else if (res.data.ack === "Failure") {
          dispatch(storeFailure(res.data.status));
        }
      })
      .catch(err => {
        throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};